module.exports = __webpack_public_path__ + "static/media/spades_2.90f99efc.png";